import React from "react";

const Pcs: React.FC<{ data: any }> = ({
    data,
}) => {
    return (
        <div style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
        }}>
            <h4 style={{ margin: 0, marginLeft: "1.5rem", marginTop: "1rem", marginBottom: "0.5rem" }}>{data.location}</h4>
            <h5 style={{ margin: 0, marginLeft: "1.5rem", marginBottom: "1.5rem" }}>
                {data.location && data.location.includes("Loan")
                    ? "Laptop Loan"
                    : "Desktop PCs"}
            </h5>

            <div style={{ display: "flex" }}>
                <div style={{ display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1, textAlign: "center", paddingBottom: "1rem" }}>
                    <span
                        style={{ color: "#00", fontSize: 36, marginBottom: "0.5rem" }}
                    >
                        {data.free}
                    </span>
                    <div style={{ fontWeight: 500 }}>Free</div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1, textAlign: "center", paddingBottom: "1rem" }}>
                    <span
                        style={{ color: "#000", fontSize: 36, marginBottom: "0.5rem" }}
                    >
                        {data.seats}
                    </span>
                    <div style={{ fontWeight: 500 }}>Total</div>
                </div>
            </div>
        </div>
    );
};

export default Pcs;
